import { useNavigate } from "react-router-dom";
import menuIcon from "../../assets/icons/menu-line.svg";
import { useRef, useState } from "react";
import SidebarDrawer from "../sidebar/sidebar-drawer";
import { useEffect } from "react";
import { api } from "../../redux/apis/api";
import { useRole } from "../../context/role/RoleContext";
import logo from "../../assets/icons/logo.svg";
import dotsIcon from "../../assets/icons/more-fill.svg";

const Navbar = () => {
  const navigate = useNavigate();
  const { state, dispatch } = useRole();
  const [sidebarOpen, setSidebarrDrawerOpen] = useState(false);
  const [profileData, setProfileData] = useState(null);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const dropdownRef = useRef(null);

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
        setDropdownOpen(false);
      }
    };

    if (dropdownOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    } else {
      document.removeEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [dropdownOpen]);

  const fetchProfile = async () => {
    var data = await api
      .post(`/ffadmin/auth/fetch-profile`)
      .then((res) => {
        setProfileData(res.data?.data);
        const userdata = {
          id: res.data?.data?.id,
          name: res.data?.data?.name,
          email: res.data?.data?.email,
          phone_number: res.data?.data?.phone_number,
          profile_picture: res.data?.data?.profile_picture,
          role: res.data?.data.role,
        };

        const roleData = res.data?.data;
        if (roleData) {
          dispatch({ type: "SET_ROLE", payload: userdata });
        }
        return userdata;
      })
      .catch((err) => {
        console.error("API Error:", err);
      });
  };

  useEffect(() => {
    const getProfile = async () => {
      try {
        const data = await fetchProfile();
        // const userdata = {
        //   id: data?.id,
        //   name: data?.name,
        //   email: data?.email,
        //   phone_number: data?.phone_number,
        //   profile_picture: data?.profile_picture,
        //   role: data?.role,
        // };
        // dispatch({ type: "SET_ROLE", payload: userdata });
      } catch (error) {
        console.error("Failed to fetch role:", error);
      }
    };

    getProfile();
  }, [dispatch]);

  return (
    <nav className="bg-background shadow-custom-soft rounded-lg text-darkText p-3 px-5 w-full">
      <SidebarDrawer
        open={sidebarOpen}
        onClose={() => setSidebarrDrawerOpen(false)}
      />
      <div className="flex justify-between items-center">
        <div className="flex gap-2 items-center">
          <div className="lg:hidden">
            <img
              onClick={() => setSidebarrDrawerOpen(true)}
              src={menuIcon}
              alt="="
              width={18}
            />
          </div>

          <h1 className="uppercase font-fw_600 mt-1">
            <img src={logo} alt="logo" width={128} />
          </h1>
        </div>

        <div></div>
        <div className="flex gap-5 items-center relative">
          <p>{profileData?.name}</p>
          <div className="hidden md:block">
            <button
              onClick={() => {
                localStorage.removeItem("accessToken");
                navigate("/");
              }}
              className="bg-primary text-white px-4 py-1 rounded-md text-fs_12 md:text-fs_14"
            >
              Logout
            </button>
          </div>
          <div className="md:hidden">
            <img
              src={dotsIcon}
              alt=":"
              width={18}
              height={18}
              onClick={() => setDropdownOpen(!dropdownOpen)}
              className="cursor-pointer"
            />

            {dropdownOpen && (
              <div
                ref={dropdownRef}
                className="absolute top-8 right-0 bg-white shadow-md rounded-md flex gap-2 p-2 z-[55505050505055] border min-w-[8rem]"
              >
                <button
                  onClick={() => {
                    localStorage.removeItem("accessToken");
                    navigate("/");
                  }}
                  className="bg-primary text-white px-4 py-1 rounded-md text-fs_12 md:text-fs_14"
                >
                  Logout
                </button>
              </div>
            )}
          </div>
        </div>
      </div>
    </nav>
  );
};

export default Navbar;
